<template>
    <div class="tab-content p-2 text-center" v-if="!isLoaded">
        {{ $t('loading') }}
    </div>
    <div v-else>
        <div class="mx-auto col-lg-4 col-md-6 col-sm-12 header-margin">
            <div class="text-center p-2">
                <h3>{{ $t('auth.login') }}</h3>
            </div>
            <div class="p-2">
                <div class="info-box mb-5">
                    <small class="text-muted">{{ $t('aube_quest.connect.quest_information') }}</small>
                    <div>Quest ID: {{ formData.questId }}</div>
                    <div>Connector ID: {{ formData.connectorMemberId }}</div>
                    <div>{{ $t('aube_quest.connector_start_date') }}: {{ formData.joinedDate }}</div>
                    <div class="text-danger">{{ errors.questId ? $t('aube_quest.verify_error.' + errors.questId) : '' }}</div>
                </div>
            </div>
            <div class="p-2">
                <form @submit.prevent="handleLogin">
                    <div class="form-group text-left">
                        <label for="email">{{ $t('account.email') }}</label>
                        <input id="email" type="text" v-model="formData.account" class="form-control" v-bind:class="{ 'is-invalid': errors.account}"/>
                        <div class="is-invalid"></div>
                        <div class="invalid-feedback">{{ errors.account ? $t('errors.' + errors.account) : '' }}</div>
                    </div>

                    <div class="form-group text-left mt-3">
                        <label for="password">{{ $t('account.edit.password') }}</label>
                        <input id="password" type="password" v-model="formData.password" class="form-control" v-bind:class="{ 'is-invalid': errors.password}"/>
                        <div class="is-invalid"></div>
                        <div class="invalid-feedback">{{ errors.password ? $t('errors.' + errors.password) : '' }}</div>
                        <div class="invalid-feedback">{{ errors.login ? $t('errors.' + errors.login) : '' }}</div>
                    </div>
                    <div class="form-check">
                        <input v-model="formData.member" name="member" type="checkbox"
                               class="form-check-input" id="member">
                        <label class="form-check-label-login" for="member">
                            {{ $t('auth.remember') }}
                        </label>
                    </div>
                    <div class="text-center p-2">
                        <button type="submit" class="btn btn-primary">
                            {{ $t('aube_quest.btn_login') }}
                        </button>
                    </div>
                    <div class="text-center mt-3 text-black">
                        <router-link to="/forgot-password-quest">{{ $t('title.forgotPassword') }}</router-link>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import LanguageService from '../../../services/LanguageService';
import UserService from '../../../services/UserService';
import AuthUtil from '../../../utils/AuthUtil';
import RecaptchaMixin from '../../../utils/RecaptchaMixin';
import questService from "../../../services/QuestService";

export default {
    name: 'login-quest',
    mixins: [RecaptchaMixin],
    data() {
        return {
            errors: this.getDefaultFields(),
            formData: {
                questId: null,
                account: '',
                password: '',
                member: false,
                connectorMemberId: null,
                joinedDate: null
            },
            isLoaded: false,
            service:'',
        }
    },
    created() {
        this.formData.questId = localStorage.getItem('questId');
        this.formData.token = localStorage.getItem('token');
        if (!localStorage.getItem('questId')) {
            this.errors.questId = 'quest_id_not_found'
        } else {
            this.getConnector(this.formData.questId);
        }
        this.isLoaded = true;

        // fake value for service
        this.service = 'connector'
    },
    methods: {
        async handleLogin() {
            this.errors = this.getDefaultFields();
            this.language = LanguageService.getCurrentLanguageCode();
            const recaptchaToken = await this.recaptchaGetKey();
            try {
                const result = await UserService.loginQuest(
                    this.formData.account,
                    this.formData.password,
                    this.formData.member,
                    this.language,
                    recaptchaToken
                );
                UserService.setLogin(result.data.auth);
                if (result.data.user.quest != null && result.data.user.quest.quest_id !== this.formData.questId) {
                    this.errors.login = 'LOGIN_FAIL_INVALID_QUEST_ID'
                    await UserService.revokeToken(AuthUtil.getAuthToken());
                    AuthUtil.clearAuth();
                } else {
                    await this.$router.push('/');
                }
            } catch (e) {
                e.response.data.errors.forEach(error => {
                    if (error.field) {
                        this.errors[error.field] = error.message[0];
                    }
                });
            } finally {
            }
        },
        getDefaultFields() {
            return {
                account: '',
                password: '',
                member: false,
                member_type: '',
                is_suspended: '',
                recaptchaToken: '',
                redirectUrl: '',
                login: '',
                questId: '',
                connectorMemberId: '',
                joinedDate: '',
            }
        },
        async getConnector (questId) {
            try {
                const result = await questService.getConnectorByQuestId(questId);
                this.formData.questId = result.data.quest_id;
                this.formData.connectorMemberId = result.data.connector_id;
                this.formData.joinedDate = result.data.joined_date;
            } catch (error) {
            }
        }
    }
}
</script>

<style scoped>

.box-area p {
    margin-top: 2px;
    margin-bottom: 2px;
    padding-top: 1px;
}

/*ボタンのスタイル*/
.btn-primary {
    background: #451493 !important;
    border-color: #451493 !important;
}

.btn-primary:hover {
    color: #fff !important;
    background-color: #350f71 !important;
    border-color: #300e66 !important;
}

.info-box {
    background-color: #f8f9fa;
    padding: 15px;
    border-radius: 4px;
    margin-bottom: 20px;
}

.form-check-label-login{
    margin-bottom: 0;
    white-space: nowrap;
}
.btn-primary:hover {
    color: #fff !important;
    background-color: #350f71 !important;
    border-color: #300e66 !important;
}
</style>

<style lang="scss">
.redirectingCover {
    background-color: rgb(255, 255, 255, 0.75);
    min-width: 100%;
    min-height: 100%;
    position: fixed;
    top: 0;
    z-index: 3;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: -15px;
}
.fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
</style>
